import React from 'react'
import ReactDOM from 'react-dom'
import "antd/dist/antd.css"
import './index.css'
import App from './App'
import * as serviceWorker from './serviceWorker'
import Amplify from 'aws-amplify'
import { Provider } from "react-redux"
import ReactBreakpoints from 'react-breakpoints'

import config from './Util/Amplify'
import { store } from "./Redux/store"

Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID
  },
  Storage: {
    region: config.s3.REGION,
    bucket: config.s3.BUCKET,
    identityPoolId: config.cognito.IDENTITY_POOL_ID
  },
  API: {
    endpoints: [
      {
        name: "test",
        endpoint: config.apiGateway.URL,
        region: config.apiGateway.REGION
      },
    ]
  }
});
const breakpoints = {
  xs: 480,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1600
}


ReactDOM.render(
  <Provider store={store}>
    <ReactBreakpoints breakpoints={breakpoints}>
      <App />
    </ReactBreakpoints>
  </Provider>,
  document.getElementById('root')
);


//Disable Zoom
/*document.addEventListener('touchmove', function (event) {
  // @ts-ignore
  if (event.scale !== 1) { event.preventDefault(); }
}, { passive: false });*/

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
